export const PERSISTENT_OPEN_WHEN_HIDDEN = true;

